import { BrandLogo } from '@kontentino/ui';
import getSocialMediaTypeForBrandLogo from 'app/utils/getSocialMediaTypeForBrandLogo';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';

interface Props {
  label: string;
  pageLogoSrc?: string;
  pageType?: number;
}

const ReportPreviewProfileLabel = ({ label, pageLogoSrc, pageType }: Props) => {
  const showLogo = pageType != null;
  const socialMediaType = showLogo
    ? getSocialMediaTypeForBrandLogo(pageType)
    : undefined;

  return (
    <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
      {showLogo ? (
        <BrandLogo
          size={32}
          iconSize={getYtLogoGuidelineSize(12, pageType)}
          name={label}
          src={pageLogoSrc}
          socialMediaType={socialMediaType}
        />
      ) : null}
      <div className="tw-flex tw-min-w-0 tw-flex-col tw-items-start tw-justify-center">
        <span
          translate="no"
          className="tw-truncate tw-text-sm tw-font-semibold tw-text-grayscale-180"
        >
          {label}
        </span>
      </div>
    </div>
  );
};

export default ReportPreviewProfileLabel;
